/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonParty,
    JsonPartyFromJSON,
    JsonPartyFromJSONTyped,
    JsonPartyToJSON,
} from './JsonParty';

/**
 * 
 * @export
 * @interface ApiResultOfJsonParty
 */
export interface ApiResultOfJsonParty {
    /**
     * 
     * @type {JsonParty}
     * @memberof ApiResultOfJsonParty
     */
    data?: JsonParty;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonParty
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonParty
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonParty
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonParty
     */
    result?: ApiResultOfJsonPartyResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonPartyResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonPartyFromJSON(json: any): ApiResultOfJsonParty {
    return ApiResultOfJsonPartyFromJSONTyped(json, false);
}

export function ApiResultOfJsonPartyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonParty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonPartyFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonPartyToJSON(value?: ApiResultOfJsonParty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonPartyToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

